import { CurrencyEnum } from '_app/graphql/generated/graphql'
import {
  Base,
  BaseGroup,
  BaseSizeConfig,
  BaseType,
  Maybe,
  Scalars,
  Element as ElementAPI,
  EngraveProduct as EngraveProductAPI,
  PriceMap as PriceMapAPI,
  Translation as TranslationAPI,
  VariantElement as VariantElementAPI,
} from '../graphql/microservice/generated/graphql'
import { Engraving, EngravingEntity } from './cms'

export * from '../graphql/microservice/generated/graphql'
export interface FetchedElement
  extends Omit<
    ElementAPI,
    'upsell_products' | 'image' | 'name' | 'sku' | 'thumbnail'
  > {
  options?: (ElementOption | undefined)[];
}

type ExtendedFetchedElement = FetchedElement &
  Pick<ElementAPI, 'upsell_products' | 'image' | 'name' | 'sku' | 'thumbnail'>;

export interface Element extends Omit<ExtendedFetchedElement, 'price'> {
  price: {
    currency: CurrencyEnum;
    value: number;
  };
}

export interface ElementOption {
  __typename: string;
  title: string;
  required: boolean;
  sort_order: number;
  uid: string;
  value?: {
    code: string;
    max_characters: number;
    pendant: string;
    pendant_idx: number;
    placement: string;
    price: number;
    price_type: string;
    sku: string;
    uid: string;
  };
}

export interface AssignedElement extends Element {
  slotId: string;
}

export interface VariantElement extends Omit<VariantElementAPI, 'element'> {
  element: ExtendedFetchedElement;
}

export interface UpsellProduct {
  [key: string]: string | number | null;
  alfabet_swatch: number | null;
  cyfry_swatch: number | null;
  kolor3_swatch: number | null;
  kolor_emalii_swatch: number | null;
  kolor_kamienia_swatch: number | null;
  material_swatch: number | null;
  rodzaj_kamienia_swatch: number | null;
  rozmiar_swatch: number | null;
  znaki_zodiaku_swatch: number | null;
  url_key: string | null;
  sku: string | null;
  name: string | null;
}

export interface Translation extends TranslationAPI {
  [key: string]: string | undefined;
}

export interface EngraveProduct extends EngraveProductAPI {
  [key: string]: string | PriceMap | Translation | undefined;
  priceMap: PriceMap;
}

export interface PriceMap extends PriceMapAPI {
  [key: string]: Maybe<Scalars['Float']> | string | undefined;
}

export interface ConfigReq {
  baseTypeId?: string;
  baseGroupId?: string;
  baseId?: string;
  materialId?: string;
  additionalMaterialId?: string;
  baseSizeConfigId?: string;
  elements?: AssignedElement[];
  activeType?: CustomizationType;
}

export type Configuration = {
  baseGroupId: string;
  baseId: string;
  materialId: string | undefined;
  additionalMaterialId: string | undefined;
  baseSizeConfigId: string;
  elements: AssignedElement[];
};

export interface ConfiguratorProps {
  baseTypes: BaseType[];
  baseGroups: BaseGroup[];
  bases: Base[];
  baseSizes: BaseSizeConfig[];
  configuration: Configuration;
  product_url?: string;
  engravingsData: EngravingEntity[];
}

export enum CustomizationType {
  MATERIALS_COLORS = 'materials_colors',
  MATERIALS = 'materials',
  COLORS = 'colors',
  SIZES = 'sizes',
  ELEMENTS = 'elements',
  SUMMARY = 'summary',
  ENGRAVING = 'engraving',
}

export enum STEPS {
  MATERIAL,
  SIZE,
  ELEMENTS,
  ENGRAVING,
  SUMMARY,
}

export type Tab = {
  isAvailable: boolean;
  label?: string;
  customizationType?: CustomizationType;
  step: STEPS;
};

export type ConfigLocal = Partial<ConfigReq>;
